import { apiClient } from "@/shared/api/apiClient";
import type { Favorite, FavoriteTargetType } from "@/shared/api/types";

/** Identifies a favoritable card: its type, the entity id, and the package it lives in. */
export interface FavoriteRef {
  targetType: FavoriteTargetType;
  targetId: string;
  packageId: string;
}

/** Current user's favorites across all card types, enriched for the sidebar. */
export const listFavorites = (): Promise<Favorite[]> =>
  apiClient.get("/publisher-admin/favorites").then((r) => r.data);

export const addFavorite = (ref: FavoriteRef): Promise<void> =>
  apiClient.post("/publisher-admin/favorites", ref);

export const removeFavorite = (ref: FavoriteRef): Promise<void> =>
  apiClient.delete("/publisher-admin/favorites", { params: ref });
